import React, { useCallback, useContext, useEffect } from 'react'
import Button from '@material-ui/core/Button'

import Dialog from '@material-ui/core/Dialog'
import HouseIcon from '@material-ui/icons/House'
import PhoneIcon from '@material-ui/icons/Phone'
import { IconButton, Typography } from '@material-ui/core'
import ForwardIcon from '@material-ui/icons/Forward'
import Link from 'next/link'
import { Scrollbars } from 'react-custom-scrollbars'
import Grid from '@material-ui/core/Grid'
import SessionContext from '../contexts/SessionContext'
import CloseIcon from '@material-ui/icons/Close'
import Autocomplete from 'react-google-autocomplete'
export default function StoreDialog(props) {
  const zipcode = ''
  const [stores, setStores] = React.useState([])
  const [page, setPage] = React.useState(1)
  const { actions, config } = useContext(SessionContext)
  const [formatted_address, SetFormattedAddress] = React.useState('')
  const handleClose = useCallback(slug => {
    props.setOpen(false)
  })

  const getStoresByAddress = async place => {
    await getStores(zipcode, place, page)
  }

  const getStores = async (zip, place, page) => {
    let headers = {
      'Content-Type': 'application/json',
    }

    let res = await fetch('/api/getstores', {
      method: 'post',
      headers: headers,
      body: JSON.stringify({
        zipcode: zip,
        place: place,
        page: page,
      }),
    })
    let data = await res.json()
    if (page > 1) {
      let newStores = stores.concat(data.stores)
      setStores(newStores)
      setPage(data.page)
    } else {
      setStores(data.stores)
    }
  }


  useEffect(() => {
    if (props.open) {
      getStores('', '', '')
    }
  }, [props.open])
  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: 'rgba(35, 49, 86, 0.8)',
    }
    return <div style={{ ...style, ...thumbStyle }} {...props} />
  }

  const CustomScrollbars = useCallback(props => (
    <Scrollbars renderThumbVertical={renderThumb} {...props} />
  ))

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="height-cus"
      >
        <div className="modal-sec">
          <h1 className="dialog-head">Find Nearby Stores</h1>{' '}
          <IconButton
            className="close-btn"
            onClick={() => {
              props.setOpen(false)
            }}
          >
            <CloseIcon></CloseIcon>
          </IconButton>
          <div className="field-spacing">
            <Autocomplete
              className="full-width place-autocomplete"
              apiKey={config?.firebase_api_key}
              options={{
                types: ['address'],
                fields: [
                  'address_components',
                  'geometry.location',
                  'place_id',
                  'formatted_address',
                ],
                componentRestrictions: {
                  country: ['us'],
                },
              }}
              onPlaceSelected={React.useCallback(place => {
                getStoresByAddress(place)
                if (place && place.hasOwnProperty('geometry')) {
                  actions.setAddress(place)
                  SetFormattedAddress(place.formatted_address)
                }
              })}
              onChange={React.useCallback(() => {
                if (document.getElementsByClassName('pac-target-input')[0].value == '') {
                  SetFormattedAddress('')
                  getStores('', '', '')
                }
              })}
              defaultValue={formatted_address ? formatted_address : ''}
            />
            {formatted_address ? (
              <IconButton
                className="close-btn search-place"
                onClick={ () => {
                  localStorage.removeItem('userAddress')
                  if (document.getElementsByClassName('pac-target-input')[0]) {
                    document.getElementsByClassName('pac-target-input')[0].value = ''
                  }
                  SetFormattedAddress('')
                  getStores('', '', '')
                }}
              >
                <CloseIcon></CloseIcon>
              </IconButton>
            ) : (
              ''
            )}
          </div>
          <h2>
            <span>Our Stores</span>
          </h2>
          <CustomScrollbars
            autoHide
            autoHideTimeout={500}
            autoHideDuration={200}
            className="scroll-outer scroll-blk-modal"
          >
            {stores && stores.length > 0 ? (
              stores.map((store, index) => (
                <div key={index} className="address-blk">
                  <h3>
                    <HouseIcon className="cus-icon"></HouseIcon>
                    {store.config.bizname}
                  </h3>
                  <p>
                    {' '}
                    {store.config.bizname}, {store.config.bizaddress}, {store.config.bizsuburb},{' '}
                    {store.config.bizstate}, {store.config.bizcountry}, {store.config.bizpostcode}
                  </p>
                  <div className="grey-blk">
                    <PhoneIcon className="icon-sm"></PhoneIcon>
                    <span>{store.config.biznumber}</span>
                  </div>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {store.hasOwnProperty('pickup_available') && store.pickup_available && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          className="no-btn"
                        >
                          Pickup
                        </Button>
                      )}
                      {store.hasOwnProperty('delivery_available') && store.delivery_available && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          className="no-btn"
                        >
                          Delivery
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  <Grid className="actions" container spacing={2}>
                    <Grid item xs={12} className="right-aligned">
                      <Link
                        onClick={handleClose}
                        as={'/store/' + store.slug}
                        href="/store/[storeSlug]"
                      >
                        <span>
                          {' '}
                          <div className="icon-btn">
                            <div className="icon-blk"></div>
                            <div className="text-blk">
                              Select Store <ForwardIcon></ForwardIcon>
                            </div>
                          </div>
                        </span>
                      </Link>
                    </Grid>
                  </Grid>
                </div>
              ))
            ) : (
              <Typography variant="h3">No Stores Found in Your Area</Typography>
            )}
          </CustomScrollbars>
        </div>
      </Dialog>
    </div>
  )
}
